import { render, staticRenderFns } from "./IndesignFileExample.vue?vue&type=template&id=1e6926f2&scoped=true&"
import script from "./IndesignFileExample.vue?vue&type=script&lang=ts&"
export * from "./IndesignFileExample.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6926f2",
  null
  
)

export default component.exports